import React from 'react';
import { connect } from 'react-redux';

import { isTaskCompletedSelector } from '../../../../../redux/tasks/taskEntities/selectors';
import { useIntl } from 'react-intl';

const MarkAsLabel = ({ isCompleted }) => {
  const intl = useIntl();

  return isCompleted
    ? intl.formatMessage({ id: 'MARK_INCOMPLETE', defaultMessage: 'Mark Incomplete' })
    : intl.formatMessage({ id: 'MARK_COMPLETE', defaultMessage: 'Mark Complete' });
}

function mapStateToProps(state, props) {
  return {
    isCompleted: isTaskCompletedSelector(state, props),
  };
}

export default connect(mapStateToProps)(MarkAsLabel);
